import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Auth0Service } from '../auth/services/auth0.service';

/**
 * Auth Interceptor
 *
 * Adds Authorization header with Bearer token to HTTP requests
 * Uses token from Auth0Service (single source of truth)
 *
 * Following Auth0 best practices:
 * - Uses cached token from Auth0Service
 * - Auth0Service syncs with localStorage when React app updates token
 * - Ensures consistent token usage across Angular app
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth0Service = inject(Auth0Service);

  // Skip auth if not authenticated
  if (!auth0Service.isAuthenticated()) {
    return next(req);
  }

  // Get token from Auth0Service (single source of truth)
  // Auth0Service syncs with localStorage when React app updates token
  const accessToken = auth0Service.getAccessToken();
  
  if (accessToken) {
    const clonedReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    return next(clonedReq);
  }

  // No token available - proceed without Authorization header
  // Server will handle 401 appropriately
  return next(req);
};

